import { Button, Tooltip } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const HelpMenuButton = () => {

    return (
        <Tooltip title="Help Menu" arrow placement="top">
            {/* <Button sx={{ color: "#ffffff", p: 0 }} onClick={doLogOut}> */}
            <HelpOutlineIcon sx={{ color: "#ffffff", p: 0 }} />
            {/* </Button> */}
        </Tooltip>
    );
};

export default HelpMenuButton;
